const ENV_DEVELOPMENT = 'development'
// const ENV_DEVOPS_QA = 'devops-qa'
// const ENV_DEVOPS_STAGING = 'devops-staging'

interface ConfigType {
  ENVIRONMENT: string
  PROXIMA_BACK_END_V2_BASE_API_URL: string
}
const CONFIG: ConfigType = {
  ENVIRONMENT: '',
  PROXIMA_BACK_END_V2_BASE_API_URL: ''
}

const env = import.meta.env

CONFIG.ENVIRONMENT = env.VITE_ENVIRONMENT ?? ENV_DEVELOPMENT
CONFIG.PROXIMA_BACK_END_V2_BASE_API_URL = env.VITE_PROXIMA_BACK_END_V2_BASE_API_URL ?? ''

export default CONFIG
